// OK 17/10/2024

import { createContext } from 'react';

export const AuthContext = createContext<any | null>(null);

